import React from 'react';
import { useTranslation } from '../../i18n';

export const RoomCodeDisplay: React.FC<{ code: string }> = ({ code }) => {
  const { t } = useTranslation();
  return (
    <span
      className="host-qr-room-code-display"
      aria-label={t('lobby.gameSelection.roomCodeAria', { code })}
    >
      {code}
    </span>
  );
};
